import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cl-file-download-link',
    templateUrl: './file-download-link.component.html',
    styleUrl: './file-download-link.component.less',
    standalone: false
})
export class FileDownloadLinkComponent {

  @Input() fileName: string;
  @Input() showIcon: boolean = true;
  @Input() breakText: boolean = true;
  @Output() downloadClicked: EventEmitter<void> = new EventEmitter();

  download(): void {
    this.downloadClicked.emit();
  }
}
